/* eslint-disable jsx-a11y/anchor-is-valid */
// LoginPage.js

import React, { useState, useEffect, useMemo  } from 'react';
import './styles.css';
import axios from 'axios';
import HeaderLogged from './HeaderLogged';
import { Link, json } from 'react-router-dom';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import CreatableSelect from 'react-select/creatable';

const FileList = ({ fileList }) => {
    const [options, setOptions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(9); // Defina o número de itens por página aqui
    const [gridData,setGridData] = useState([]); // Insira seus dados do grid aqui
    const [jsonData, setJsonData] = useState(null)
    const [selectedIds, setSelectedIds] = useState([]);
    const [externalId, setExternalId] = useState('');
    const [configuration, setConfiguration] = useState('');
    const [optionsSelect, setOptionsSelect] = useState([]);
    const [batchItemsChecker, setBatchItemsChecker] = useState(false);

    const queryParams = new URLSearchParams(window.location.search);
    const processedBatchID = queryParams.get('batchid');
    const [haveBatchID, sethaveBatchID] = useState([]);
    const [haveBatchIDCheckbox, setHaveBatchIDCheckbox] = useState();
    
    // Função para calcular o índice inicial e final dos itens na página atual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = gridData.slice(indexOfFirstItem, indexOfLastItem);

    // Função para atualizar a página atual
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const toggleSelection = (id) => {
      if (selectedIds.includes(id)) {
        setSelectedIds(prevIds => prevIds.filter(item => item !== id));
      } else {
        setSelectedIds(prevIds => [...prevIds, id]);
      }
    };

    const handleExternalIdChange = (e) => {
      setExternalId(e.target.value);
    };
    const handleConfigurationChange = (selectedOption) => {
     
      if (selectedOption) {
        setConfiguration(selectedOption.value);
      } else {
        setConfiguration('');
      }
      
    };

    const Consulta = async () => 
      {
        const data = JSON.parse(localStorage.getItem("user"));
        setBatchItemsChecker(false);

        const fetchData = async () => {
          const data = JSON.parse(localStorage.getItem("user"));
          const requestBody = new FormData();
          requestBody.append('companyID', data.companyID);
          requestBody.append('limit', 50);
          
          // Adicione os filtros no requestBody
          if (externalId) {
            requestBody.append('externalId', externalId);
          }
          if (configuration) {
            requestBody.append('configurationid', configuration);
          }
          if (haveBatchID) {
            requestBody.append('haveBatchID', haveBatchID);
          }
          try {
            const response = await fetch(
              process.env.REACT_APP_BASE_URL + '/api/ReadData',
               {
              method: 'POST',
              body: requestBody
            });
        
            if (!response.ok) {
              throw new Error('Error occurred while fetching data.');
            }
        
            const data = await response.json();
            setOptions(data);
            setGridData(data);
          } catch (error) {
            console.error(error);
          }
        };
  
        fetchData();
      };

    const downloadCSV = async () => {
      try {
        
        const jsonData = { DataFilter: selectedIds };
        const response = await axios.post(process.env.REACT_APP_BASE_URL + '/api/DataToCsv',jsonData );
        
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'data.csv';
        link.click();
      } catch (error) {
        alert(error);
      }
    };

    

    const handleClose = (e) => {
      setJsonData(null);
      document.body.classList.remove('disable-scroll');
    };


    useEffect(() => {
      const data = JSON.parse(localStorage.getItem("user"));
      const fetchDataConfig = async () => {
        const requestBody = new FormData();
        requestBody.append('companyID', data.companyID);
    
        try {
          const response = await fetch(process.env.REACT_APP_BASE_URL + '/api/ReadConfiguration', {
            method: 'POST',
            body: requestBody
          });
    
          if (!response.ok) {
            throw new Error('Error occurred while fetching data.');
          }
    
          const data = await response.json();
          setOptionsSelect(data);
        } catch (error) {
          console.error(error);
        }
      };
    
      fetchDataConfig();
    }, []); 

    const getBatchFiles = async (batchID) => {
      const data = JSON.parse(localStorage.getItem("user"));
      const requestBody = new FormData();
      requestBody.append('companyID', data.companyID);
      requestBody.append('limit', 50);
      requestBody.append('batchID', batchID);
    
      try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + '/api/ReadData', {
          method: 'POST',
          body: requestBody
        });
    
        if (!response.ok) {
          throw new Error('Error occurred while fetching data.');
        }
    
        const data = await response.json();
        setOptions(data);
        setGridData(data);
        console.log(response)
    
        setCurrentPage(1);
        setBatchItemsChecker(true);
      } catch (error) {
        console.error(error);
      }
    };

    const getStatusLabel = (status) => {
      return (status === "T" || status === "P" ) ? "Processado" : status;
    };

  useEffect(() => {
    //verificar se o usuário está logado
    if (localStorage.getItem("user") === null) {
      window.location.href = "/";
    }
    if (processedBatchID !== null) {
      getBatchFiles(processedBatchID);
    }
    else {
      Consulta();
    }
    
  }, []); 

  function getStatus(status) {
    switch (status.toLowerCase()) {
      case "processado":
        return "badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill fs-6";
      case "erro":
        return "badge bg-danger-subtle border border-danger-subtle text-danger-emphasis rounded-pill fs-6";
      case "em processamento":
        return "badge bg-warning-subtle border border-warning-subtle text-warning-emphasis rounded-pill fs-6";
      default:
        return "";
    }
  }

  const getOptions = (optionsSelect) => {
    return [
      { label: 'Todas', value: '' }, // Adiciona um item vazio
      ...optionsSelect.map(option => ({
        label: option,
        value: option
      }))
    ];
  };

  const haveBatchIDCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setHaveBatchIDCheckbox(isChecked);
    if (isChecked) {
      sethaveBatchID("True");
    } else {
      sethaveBatchID("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    Consulta();

  }

  const memoizedOptions = useMemo(() => {
    return [
      { label: 'Todas', value: '' }, 
      ...optionsSelect.map(option => ({
        label: option,
        value: option
      }))
    ];
  }, [optionsSelect]);

  return (
    <div>
      <div className='container-fluid p-0'>
        <HeaderLogged></HeaderLogged>
        <div className="row showContentMargin" id='content'>
          <div className="col-3 col-lg-auto col-xxl-2" id='divSidebar'>
            <Sidebar></Sidebar>
          </div>
          <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>
          <form onSubmit={handleSubmit}>
          <div className="row">
          <div className="col-md-12">
            <span className="fs-3">Filtro</span>
          </div>
          <div className="col-md-4">
            <label htmlFor="externalId" className="fs-5">Id Externo:</label>
                  <input
                    type="text"
                    id="externalId"
                    className="form-control"
                    value={externalId}
                    onChange={handleExternalIdChange}
                  />
                  <div className="form-check fs-5">
                    <input className="form-check-input" type="checkbox" onChange={haveBatchIDCheckboxChange} checked={haveBatchIDCheckbox} />
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                      Em Lote
                    </label>
                  </div>
                </div>
            <div className="col-md-4">
              <label htmlFor="configuration" className="fs-5">Configuração:</label>
              <CreatableSelect
                options={memoizedOptions}
                id="configuration"
                onChange={handleConfigurationChange}/>
            </div>
                
            <div className="col-md-4">
            <br></br>
            <button type="submit" className="btn btn-success btn-lg">Filtrar</button>
            </div>
            </div>
            </form>
            <br></br>
            <br></br>
            <div className="row">
              <div className='col-12 col-xxl-12 col-lg-12' id='divList'>
                <ul className='list-group'>

                {currentItems.map((item) => (
                  <li className='list-group-item' key={item.ID}>
                    <div className="row">
                    <h5>
                        {/* <input className='form-check-input me-4'
                            type="checkbox" 
                            checked={selectedIds.includes(item.ID)} 
                            onChange={() => toggleSelection(item.ID)} 
                          /> */}
                        {item.ProcessDate && item.ProcessDate + " -"} Id Externo: {item.externalID}
                      </h5>
 
                      <div className="col-md-6 mt-2">
                        <div>
                          <h5>
                            <input className='form-check-input me-4' style={{border: "2px solid"}}
                              type="checkbox" 
                              checked={selectedIds.includes(item.ID)} 
                              onChange={() => toggleSelection(item.ID)} 
                            />
                            {getStatusLabel(item.Status) === "Processado"  && (
                              item.batchID === null || batchItemsChecker === true ? (
                                <Link to={`/fileprocessed/${item.ID}?fileName=${item.fileName}&type=${item.configuration}`} className='titleOverflow'>
                                  {item.fileName.split('_').slice(1)}
                                </Link>
                              ) : (
                                <a className='titleOverflow' onClick={() => getBatchFiles(item.ID)} style={{ cursor: 'pointer' }}>
                                  Lote
                                </a>
                              )
                            )}
                            {getStatusLabel(item.Status) !== "Processado" && (<span className='titleOverflow'>{item.fileName}</span>)}
                          </h5>
                        </div>

                      </div>
                      <div className="col-md-3 mt-2">
                        <h5>
                          {item.configuration}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <span className={getStatus(getStatusLabel(item.Status))}>
                          {getStatusLabel(item.Status)}
                        </span>
                      </div>
                      <div className="col-md-1">
                        {item.batchID !== null && batchItemsChecker === false && (
                          <h5>
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-archive ms-4" viewBox="0 0 20 20">
                              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5zm13-3H1v2h14zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
                            </svg>
                            Lote
                          </h5>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
                </ul>

                <div className=" text-center">
                  {gridData.length > itemsPerPage && (
                    <div>
                      <ul className="pagination">
                      {Array.from({ length: Math.ceil(gridData.length / itemsPerPage) }).map((_, index) => (
                        <li className="page-item" key={index} onClick={() => paginate(index + 1)}><span className="page-link">{index + 1}</span></li>
                      ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="form-group text-center">
                <button onClick={downloadCSV}>Download CSV</button>
                </div>

                {jsonData && (
                <div className="overlay-panel">
                <div className="overlay-content">
                  <textarea value={jsonData} readOnly />
                  <br></br>
                  <a href="#" onClick={handleClose}>Fechar</a>
                </div>
                
              </div>
              )}
            </div>
              </div>


              
              
          </main>
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
</div>
    
  );
};

export default FileList;

